import { SEISMIC_SURVEY } from '@core/core/constants'
import {
  continueUploadSurvey2dFiles,
  selectActiveProject,
  selectActiveProjectName,
  uploadSurvey2dFiles,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { DataToSendEvent } from '@core/core/types'
import { getImportDataAnalyticParams } from '@core/core/utils'
import type { FC } from 'react'

import { SurveyType } from '../types'
import { AddingFilesModal } from './AddingFilesModal'
import { CoordinateSelectionOption } from './constants'
import type { AddingFilesModalContainerPropsType as PropsType, FormDataType } from './types'
import { useAddingFiles } from './useAddingFiles'
import { useGetDomainItems } from './useGetDomainItems'
import { useGetSurveyItems } from './useGetSurveyItems'

const AddingFilesSurvey2dModalContainer: FC<PropsType> = ({ files = null, treeObject }) => {
  const dispatch = useAppDispatch()
  const domainItems = useGetDomainItems()
  const activeProject = useAppSelector(selectActiveProject)
  const activeProjectName = useAppSelector(selectActiveProjectName)

  const addFilesInSurvey = (filesCollection: File[], formData?: FormDataType) => {
    const files = filesCollection.map(file => ({
      data: file,
      fileName: file.name,
    }))

    if (formData?.survey2D) {
      dispatch(
        continueUploadSurvey2dFiles({
          projectId: activeProject.id,
          data: {
            files,
            surveyId: formData.survey2D.id,
            surveyName: formData.survey2D.name ?? undefined,
            projectId: activeProject.id,
            domainType: formData.survey2D.domain,
          },
        }),
      )
    } else {
      let coordsTemplates = undefined
      if (
        formData?.coordinateSelectionRule !== CoordinateSelectionOption.Auto &&
        formData?.coordsTemplates?.xOffset &&
        formData.coordsTemplates.yOffset
      ) {
        coordsTemplates = {
          xOffset: formData.coordsTemplates.xOffset,
          yOffset: formData.coordsTemplates.yOffset,
        }
      }
      dispatch(
        uploadSurvey2dFiles({
          data: {
            files,
            name: formData?.objectName,
            domainType: formData?.domain?.id,
            coordsTemplates,
            projectId: activeProject.id,
          },
        }),
      )
    }
  }

  const data: DataToSendEvent = {
    id: 'import from file_seismic_end',
    params: getImportDataAnalyticParams(activeProjectName, 'Survey2D'),
  }
  const { visibleModal, activeFileReady, isOneFileDownloaded, onSave, onSaveForAll, onCancel } =
    useAddingFiles(files, data, undefined, addFilesInSurvey)
  const { survey2DItems } = useGetSurveyItems(activeProject.id)
  return (
    <AddingFilesModal
      isModalOpen={visibleModal}
      isOneFileDownload={isOneFileDownloaded}
      fileName={activeFileReady?.name ?? ''}
      domainItems={domainItems}
      survey2DItems={survey2DItems}
      initialSurveyGroup={SurveyType.TwoD}
      treeObject={treeObject}
      uploadingType={SEISMIC_SURVEY}
      onCancel={onCancel}
      onSave={onSave}
      onSaveForAll={onSaveForAll}
    />
  )
}

export { AddingFilesSurvey2dModalContainer }
